import { render, staticRenderFns } from "./AddFreelancer.vue?vue&type=template&id=c9727d7e"
import script from "./AddFreelancer.vue?vue&type=script&lang=js"
export * from "./AddFreelancer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports